const themeData = [
    {
        name: "Indigo",
        primaryColor: "#3f51b5",
        accentColor: "#7986cb",
        textColor: "#212121"
    },
    {
        name: "Old_Default",
        primaryColor: "#339989",
        accentColor: "#7de2d1",
        textColor: "#424242",
    },
    {
        name: "Dessert",
        primaryColor: "#46211a",
        accentColor: "#693d3d",
        textColor: "#eaecef",
        linkColor: "#693d3d"
    }, {
        name: "Purple",
        primaryColor: "#9c27b0",
        accentColor: "#ce93d8",
        textColor: "#420866"
    }
    , {
        name: "Orange",
        primaryColor: "#ff9800",
        accentColor: "#ffcc80",
        textColor: "#9e5104"
    }, {
        name: "Github",
        primaryColor: "#24292E",
        accentColor: "#3F4448",
        textColor: "#CFD0D1",
        linkColor: "#eaecef"
    }, {
        name: "lightGreen",
        primaryColor: "#4caf50",
        accentColor: "#a5d6a7",
        textColor: "#1b5e20"
    }
];

export default themeData;